module.exports = __webpack_public_path__ + "a128c5ceff16d1f9e3afa438ba263aaa.png";